import { defineStore } from 'pinia';
import { ref } from 'vue';

import { ActivityDetailsModalType } from '../models';

export const useActivityDetailsModalsStore = defineStore(
  'ActivityDetailsModalsStore',
  () => {
    // State
    const activityDetailsModalType = ref<ActivityDetailsModalType | undefined>(
      ActivityDetailsModalType.None
    );

    // Actions
    function openTicketsSelectorModal(): void {
      activityDetailsModalType.value =
        ActivityDetailsModalType.TicketsSelection;
    }

    function openFullDescriptionModal(): void {
      activityDetailsModalType.value = ActivityDetailsModalType.FullDescription;
    }

    function closeModal(): void {
      activityDetailsModalType.value = ActivityDetailsModalType.None;
    }

    return {
      // State
      activityDetailsModalType,

      // Actions
      openTicketsSelectorModal,
      openFullDescriptionModal,
      closeModal,
    };
  }
);
